import React from 'react';
import PropTypes from 'prop-types';

import {Accordion, AccordionSummary, AccordionDetails} from 'views/components';
import {Stack, Divider, Box, Typography} from 'views/components';

import {Translate} from 'views/module';

import moment from 'moment-timezone';

const SlipHourDetails = (props) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const slipDetail = props.slipDetail;

  const hours = slipDetail.hours;

  const hoursSorted = hours.sort((a, b) => {
    return moment(a.eventData.startTime).diff(moment(b.eventData.startTime));
  });

  return (
    <Stack
      sx={{
        p: 2,
      }}
      spacing={1}
    >
      <Accordion
        elevation={0}
        expanded={isExpanded}
        onChange={(event, isExpanded) => setIsExpanded(isExpanded)}
        sx={{width: 1}}
        disableGutters
      >
        <AccordionSummary>
          <Typography
            sx={{
              fontWeight: 'bold',
            }}
          >
            <Translate expression='caregiver.CaregiverDetail.Payment.WorkSummary.HoursWorked.Title' />
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{py: 0, px: {xs: 0, md: 2}}}>
          <Box pt={2} ml={{xs: 1, md: 5}}>
            {hoursSorted.map((shift, index) => {
              const timezone = shift.eventData.timezone;
              const date = moment.tz(shift.eventData.startTime, timezone).format('dddd, MMM D');

              const startTime = moment.tz(shift.eventData.startTime, timezone).format('h:mm A');
              const endTime = moment.tz(shift.eventData.endTime, timezone).format('h:mm A z');
              return (
                <Box key={index} sx={{mb: 2}}>
                  <Typography sx={{fontWeight: 'bold'}}>{date}</Typography>
                  <Typography>
                    <Translate
                      expression='caregiver.CaregiverDetail.Payment.WorkSummary.HoursWorked.ShiftTile'
                      substitute={{title: shift.eventInfo?.title}}
                    />
                  </Typography>
                  <Typography>
                    <Translate
                      expression='caregiver.CaregiverDetail.Payment.WorkSummary.HoursWorked.ShiftTime'
                      substitute={{startTime, endTime}}
                    />
                  </Typography>
                  <Typography>
                    <Translate
                      expression={
                        shift.clockOutConfirmation ?
                        'caregiver.CaregiverDetail.Payment.WorkSummary.HoursWorked.ConfirmationYes' :
                        'caregiver.CaregiverDetail.Payment.WorkSummary.HoursWorked.ConfirmationNo'
                      }
                    />
                  </Typography>
                  <Divider sx={{pt: 1}} />
                </Box>
              );
            })}
          </Box>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
};

SlipHourDetails.propTypes = {
  slipDetail: PropTypes.object.isRequired,
};
export default React.memo(SlipHourDetails);
